(function () {
  function updateProgressBar() {
    var wrapper = document.querySelector(".progress-wrapper");
    var fill = document.getElementById("progress-fill");
    var textContainer = document.getElementById("progress-text");

    if (!wrapper || !fill || !textContainer) {
      console.log("Required elements not found");
      return;
    }

    var cartTotal = parseFloat(wrapper.getAttribute("data-cart-total")) || 0;

    // Get settings from global variable or data attributes
    var settings = window.cartProgressSettings || {};

    var t1 =
      settings.threshold1 ||
      parseFloat(wrapper.getAttribute("data-threshold-1")) ||
      1199;
    var t2 =
      settings.threshold2 ||
      parseFloat(wrapper.getAttribute("data-threshold-2")) ||
      1599;
    var t3 =
      settings.threshold3 ||
      parseFloat(wrapper.getAttribute("data-threshold-3")) ||
      1799;
    var d1 =
      settings.discount1 || wrapper.getAttribute("data-discount-1") || "10";
    var d2 =
      settings.discount2 || wrapper.getAttribute("data-discount-2") || "15";
    var d3 =
      settings.discount3 || wrapper.getAttribute("data-discount-3") || "20";

    // Get message templates from global settings or data attributes
    var msgTemplate1 =
      settings.message1 ||
      wrapper.getAttribute("data-message-1") ||
      "Add Items worth ₹{amount} to UNLOCK {discount1}";
    var msgTemplate2 =
      settings.message2 ||
      wrapper.getAttribute("data-message-2") ||
      "CONGRATS! YOU UNLOCKED {discount1} | ADD ₹{amount} for {discount2}";
    var msgTemplate3 =
      settings.message3 ||
      wrapper.getAttribute("data-message-3") ||
      "CONGRATS! YOU UNLOCKED {discount2} | ADD ₹{amount} for {discount3}";
    var msgComplete =
      settings.messageComplete ||
      wrapper.getAttribute("data-message-complete") ||
      "CONGRATS! YOU HAVE UNLOCKED ALL OFFERS! {discount3} APPLIED";

    function fillPlaceholders(template, amount) {
      return template
        .replace("{amount}", amount)
        .replace("{discount1}", d1)
        .replace("{discount2}", d2)
        .replace("{discount3}", d3);
    }

    var pct = 0;
    var msg = "";

    if (cartTotal < t1) {
      pct = (cartTotal / t1) * 33.33;
      msg = fillPlaceholders(msgTemplate1, Math.ceil(t1 - cartTotal));
    } else if (cartTotal >= t1 && cartTotal < t2) {
      pct = 33.33 + ((cartTotal - t1) / (t2 - t1)) * 33.33;
      msg = fillPlaceholders(msgTemplate2, Math.ceil(t2 - cartTotal));
    } else if (cartTotal >= t2 && cartTotal < t3) {
      pct = 66.66 + ((cartTotal - t2) / (t3 - t2)) * 33.34;
      msg = fillPlaceholders(msgTemplate3, Math.ceil(t3 - cartTotal));
    } else {
      pct = 100;
      msg = fillPlaceholders(msgComplete, 0);
    }

    fill.style.width = pct + "%";
    textContainer.innerHTML = msg;

    // Add full border radius when at 100%
    if (pct >= 100) {
      fill.classList.add("full");
    } else {
      fill.classList.remove("full");
    }
  }

  // Expose function globally so cart-drawer.js can call it
  window.updateProgressBar = updateProgressBar;

  // Run immediately when script loads
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateProgressBar);
  } else {
    updateProgressBar();
  }

  // Listen for cart drawer open event
  document.addEventListener("cartdrawer:opened", function () {
    setTimeout(updateProgressBar, 100);
  });

  // Also listen for cart updates
  document.addEventListener("cart:updated", function () {
    setTimeout(updateProgressBar, 100);
  });
})();
